import { getAdder, getUnitStart, format } from "../time";
import { addMonths, areIntervalsOverlapping, endOfDay, isSameDay, startOfDay, } from "date-fns";
import { sortEvents } from "../events";
const addDays = getAdder("day");
class AgendaView {
    constructor() {
        this.getBounds = (date) => {
            const start = getUnitStart("day", date);
            const end = addMonths(start, 2);
            return [start, end];
        };
        this.getNext = (date) => {
            const start = addDays(date, 1);
            return start;
        };
        this.getPrev = (date) => {
            const start = addDays(date, -1);
            return start;
        };
        this.getTitle = (date, config) => format(date, "d LLL y", { locale: config.locale });
    }
    addEvent(event) {
        this._events.push(event);
    }
    getViewModel(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _activeDate, bounds, 
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _config, displayedEvents, calendars) {
        const days = [];
        let start = startOfDay(bounds[0]);
        const end = endOfDay(bounds[1]);
        const sortedEvents = sortEvents(displayedEvents);
        this._events = displayedEvents;
        while (!isSameDay(start, end)) {
            const events = sortedEvents.filter(event => areIntervalsOverlapping({ start, end: endOfDay(start) }, { start: event.start_date, end: event.end_date }));
            if (events.length) {
                days.push({
                    date: start,
                    events,
                });
            }
            start = addDays(start, 1);
        }
        return {
            title: this.getTitle,
            addEvent: this.addEvent.bind(this),
            days,
            calendars,
        };
    }
}
export default AgendaView;
//# sourceMappingURL=agenda.js.map